import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_LAYOUT } from 'Utils/request/requestDictionary';
export const fetchLayoutConfig = (appContext: AppContext) => {
  return graphQLClient.runQuery('', appContext, {
    requestName: CORE_LAYOUT,
    queryId: CORE_LAYOUT,
  });
};
